<template lang="pug">
.post-content
  template(v-for="(s, i) in sections")
    post-content-section(
      :section="s"
      :index="i"
    )
</template>

<script>
import PostContentSection from '@/components/post/post-content__section'

export default {
  name: 'post-content',
  components: {
    PostContentSection
  },
  props: {
    post: {
      type: Object,
    },
  },
  computed: {
    sections() {
      return this.post.sections || []
    },
  },
}
</script>

<style lang="sass">
/* see App.vue for these root styles:
  --post-content-font-size: 1.25rem
  --post-content-line-height: 1.5 */

.post-content
  font-family: var(--serif-fonts)
  font-size: var(--post-content-font-size)
  line-height: var(--post-content-line-height)
  margin-top: 2rem
  margin-bottom: 4rem
  max-width: 80ch

  img
    margin: 0
    max-width: 100%

  .img-wrapper
    position: relative
    background-color: #aaa

    img
      position: absolute

.post-content__section
  margin-bottom: 1rem

  &.--img
    border: 1px solid var(--base-color)
    margin-top: 2rem
    margin-bottom: 2rem

  &.--first.--text
    font-size: 1.6rem

</style>
